module.exports = __webpack_public_path__ + "static/media/xueshan3.4f28b13a.webp";